import React, { useState } from "react";
import heic2any from "heic2any";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Resizer from "react-image-file-resizer";

const HeicToJpegZipConverter = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [zipReady, setZipReady] = useState(false);
  const [zipBlob, setZipBlob] = useState(null);
  // New state to hold error messages and display them as h1 tags
  const [errorMessages, setErrorMessages] = useState([]);

  const resizeImage = (file, index, total) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        600, // width
        600, // height
        "JPEG", // format
        70, // quality
        0, // rotation
        (resizedFile) => {
          const percent = Math.round(((index + 1) / total) * 100);
          setProgress(percent);
          resolve(resizedFile);
        },
        "file" // Return as File object
      );
    });

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const totalFiles = files.length;
    const zip = new JSZip();

    setIsProcessing(true);
    setProgress(0);
    setZipReady(false);
    setZipBlob(null);
    // Clear any previous errors
    setErrorMessages([]);

    for (let i = 0; i < totalFiles; i++) {
      const file = files[i];
      if (!file.name.toLowerCase().endsWith(".heic")) continue;
      console.log(`Starting conversion for file: ${file.name}`);
      try {
        // Step 1: Convert HEIC to JPEG Blob
        const jpegBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
        });

        // Step 2: Convert Blob to File for Resizer
        const convertedFile = new File(
          [jpegBlob],
          file.name.replace(/\.heic$/i, `.jpg`),
          { type: "image/jpeg" }
        );

        // Step 3: Resize
        const resizedFile = await resizeImage(convertedFile, i, totalFiles);
        zip.file(resizedFile.name, resizedFile);
      } catch (error) {
        console.error("Conversion error for", file.name, error);
        setErrorMessages((prev) => [
          ...prev,
          `Conversion error for ${file.name}: ${error.message}`,
        ]);
      }
    }

    const zipContent = await zip.generateAsync({ type: "blob" });
    setZipBlob(zipContent);
    setZipReady(true);
    setIsProcessing(false);
  };

  const handleDownloadZip = () => {
    if (zipBlob) {
      saveAs(zipBlob, "resized_images.zip");
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4">
        HEIC to Resized JPEG Converter
      </h2>

      {/* Display error messages (if any) in H1 tags */}
      {errorMessages.map((msg, index) => (
        <h1 key={index} className="text-red-600 text-xl mb-2">
          {msg}
        </h1>
      ))}

      <input
        type="file"
        accept=".heic"
        multiple
        onChange={handleFileChange}
        className="mb-4"
      />

      {isProcessing && (
        <div className="mb-4">
          <p className="mb-1">Processing and resizing images...</p>
          <div className="w-full bg-gray-200 rounded-full h-4">
            <div
              className="bg-blue-600 h-4 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-sm mt-1">{progress}%</p>
        </div>
      )}

      {zipReady && (
        <button
          onClick={handleDownloadZip}
          className="px-4 py-2 mt-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Download All as ZIP
        </button>
      )}
    </div>
  );
};

export default HeicToJpegZipConverter;